<template>
  <div v-if="hcCaseFlightFiles && hcCaseFlightFiles.length">
    <el-form-item
      class="custom-label__input width25"
      :label="fieldTitle"
      prop="flightFileList"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="jobInfoAttachment style-fullWidth">
            <div
              v-for="hcCaseFlightFile in hcCaseFlightFiles"
              v-bind:key="hcCaseFlightFile.id"
              class="file-uploaded input-none__border"
            >
              <div class="file clickable flex-row flex__between padding-0">
                <a
                  class="flex-row flex__left margin-left-10"
                  @click="downloadFile(hcCaseFlightFile)"
                >
                  <file-type-image
                    :fileExtention="hcCaseFlightFile.fileExtention"
                    :customClass="''"
                  />
                  <span class="">{{ hcCaseFlightFile.fileName }}</span>
                </a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
  import FileTypeImage from "../../job/FileTypeImage";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import hcCaseFlightFileService from "../../../services/maybay/hcCaseFlightFileService";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";

  export default {
    name: "hc-base-upload-readonly",
    mixins: [handleRequestErrorMixin],
    components: {FileTypeImage},
    props: ["hcCaseMasterId", "hcCaseFlightFileType"],

    data() {
      return {
        hcCaseFlightFiles: [],
        fieldTitle: null
      };
    },

    watch: {
      hcCaseMasterId() {
        this.reloadData();
      }
    },

    created() {
      this.reloadData();
    },

    methods: {
      initFieldTitle() {
        this.fieldTitle = hanhChinhUtils.initHcCaseFlightFilesFieldTitle(
          this.hcCaseFlightFileType
        );
      },

      loadHcCaseFlightFiles() {
        return hcCaseFlightFileService
          .findAllByHcCaseMasterId(this.hcCaseMasterId, this.hcCaseFlightFileType)
          .then(response => (this.hcCaseFlightFiles = response.data));
      },

      downloadFile(hcCaseFlightFile) {
        this.$emit("downloadFile", {
          hcCaseFlightFileId: hcCaseFlightFile.id,
          vbAttachmentId: hcCaseFlightFile.attachmentId
        });
      },

      reloadData() {
        this.loadHcCaseFlightFiles();
        this.initFieldTitle();
      }
    }
  };
</script>

<style scoped>
  .download-icon:hover {
    color: var(--color-blue) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-base-upload-readonly.vue